import React from 'react';
import {Box, Input as NativeInput, FormControl, Button} from 'native-base';

import {defaultProps} from './../constants';
import {message} from './../../../utils/messages';
import {KeyboardTypeOptions, StyleSheet} from 'react-native';
import {ColorType} from 'native-base/lib/typescript/components/types';
import {CopyIcon} from './../../icons';
import {isWebApp} from '../../../utils/platform/is-web';

interface Props {
  label: string;
  erroMessage?: string;
  type?: KeyboardTypeOptions;
  backgroundColor?: ColorType;
  selectedColor?: ColorType;
  value?: string;
  isRequired?: boolean;
  isReadOnly?: boolean;
  onCopy?: () => void;
}

const CopyText = (props: Props) => {
  const {
    label,
    erroMessage,
    type: typeInput,
    backgroundColor,
    value,
    selectedColor,
    isRequired,
    isReadOnly,
    onCopy: launchOnCopy,
  } = props;

  const isInvalid = () => {
    return getMessage(erroMessage ?? '').trim() !== '';
  };

  const getMessage = (text: string) => {
    return message(text).trim();
  };

  const getBackgroundColor = (): ColorType => {
    if (getValue() === '') {
      return backgroundColor;
    }

    return selectedColor;
  };

  const getValue = () => {
    if (value || value?.trim() !== '') {
      return value;
    }
    return '';
  };

  const handleCopyPress = () => {
    if (launchOnCopy) {
      launchOnCopy();
    }
  };

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl isRequired={isRequired} isInvalid={isInvalid()}>
        <FormControl.Label>{getMessage(label)}</FormControl.Label>
        <NativeInput
          {...defaultProps}
          _input={{color: '#06355E', fontWeight: 'medium'}}
          keyboardType={typeInput as KeyboardTypeOptions}
          _focus={{borderColor: getBackgroundColor()}}
          backgroundColor={getBackgroundColor()}
          borderColor={getBackgroundColor()}
          value={getValue()}
          isReadOnly={isReadOnly}
          InputRightElement={
            <Button
              size="xs"
              rounded="none"
              w="1/6"
              h="full"
              backgroundColor={getBackgroundColor()}
              onPress={() => handleCopyPress()}>
              {' '}
              {getValue() !== '' && (
                <Box marginBottom={isWebApp ? 2 : 0}>
                  <CopyIcon width={22} style={styles.copyIcon} />
                </Box>
              )}
            </Button>
          }
        />
        <FormControl.ErrorMessage>
          {getMessage(erroMessage ?? '')}
        </FormControl.ErrorMessage>
      </FormControl>
    </Box>
  );
};

const styles = StyleSheet.create({
  copyIcon: {
    marginBottom: 5,
    marginTop: -10,
  },
});

export default CopyText;
